/**
 * @file        os-basic.js
 *              Basic os info support for dcp-client internals
 *
 *              All interfaces are synchronous and read/write JS strings.
 *
 * @author      Wes Garland, wes@distributive.network
 * @date        Jul 2025
 */
'use strict';

const env = require('./dcp-env');

function declFun(api)
{
  exports[api] = () => { throw new Error(`os interface ${api} not supported on platform ${env.platform}`) };
}

function declConst(api) // eslint-disable-line no-unused-vars
{
  exports[api] = { valueOf: null, source: `uninitialized constant ${api} in os-basic for platform ${env.platform}` };
}

/* Supported APIs. */
declFun('hostname');
declFun('username');
declFun('getpid');
Object.seal(exports);

if (env.platform === 'nodejs')
{
  const { requireNative } = require('dcp/dcp-client/webpack-native-bridge');
  const os = requireNative('os');
  const process = requireNative('process');

  exports.hostname = os.hostname;
  exports.username = () => os.userInfo().username;
  exports.getpid   = () => process.pid;
}
else if (env.platform === 'pythonmonkey')
{
  /* Exports are directly injected by dcp-client/index.py so that we don't have to solve the problem of
   * embedding python code elegantly into a webpack bundle. This means that we must not use osBasic
   * during the loading of the bundle.
   */
}
